import { Content } from '@/components/app'
import { MEDIA_QUERY } from '@/constants/style'
import useLayoutStore from '@/store/layout'
import { LayoutProps } from '@/store/types'
import { useMediaQuery } from '@mui/material'

function LoginLayout( props: LoginLayoutProps ) {
    const { children, contentWidth } = props
    const matches = useMediaQuery( MEDIA_QUERY )
    const isMobile = useLayoutStore( ( { isMobile } ) => isMobile )

    return (
        <Content
            contentPadding={ isMobile ? '36px 12px' : '64px' }
            contentWidth={ contentWidth || ( matches ? 100 : 30 ) }
        >
            { children && children }
        </Content>
    )
}

export default LoginLayout

export interface LoginLayoutProps extends LayoutProps {
    contentWidth?: number
}
